// @ts-check

import TextField from '@mui/material/TextField';
import SearchIcon from '@material-ui/icons/Search';
import {lightTheme} from '../../theme/themeColors';
import InputAdornment from '@mui/material/InputAdornment';
import React, { useState, useEffect, useCallback } from 'react';

// Debounce function
const debounce = (func, wait) => {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

const SearchComponent = ({ onSearch }) => {
  const [inputValue, setInputValue] = useState('');

  // Debounce the search handler
  const debouncedSearch = useCallback(debounce(onSearch, 500), [onSearch]);

  useEffect(() => {
    debouncedSearch(inputValue);
  }, [inputValue, debouncedSearch]);

  return (
    <TextField
      value={inputValue}
      onChange={(e) => setInputValue(e.target.value)}
      variant="outlined"
      placeholder="Search"
      sx={{
        '& .MuiOutlinedInput-notchedOutline': {
          borderStyle: 'solid',
          borderColor: lightTheme.borderColor, // Example: changing the border color
          borderWidth: '1px',
          padding: '0',
        },
        '& span.notranslate': {
          display: 'none',
        },
        '& .MuiOutlinedInput-input': {
          padding: '0',
        },
        padding: '0 15px'
      }}
      InputProps={{
        sx: {
          padding: '0 15px',
          margin: ' 20px 0',
          height: '40px',
        },
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon />
          </InputAdornment>
        ),
      }}
    />
  );
};

export default SearchComponent;
